import React, {useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useForm, Controller} from 'react-hook-form'
import {setQuestions} from 'virtual_congress/exhibition_actions'
import {TextField,} from "@material-ui/core";
import axios from 'axios';
import _ from 'lodash';
import classNames from 'classnames'
import useTranslation from "../../../../virtual_congress/effects/use_translation"

export default function QuestionForm({videoRoom, options, ...props}) {

  const {handleSubmit, formState: { errors }, setError, control, reset, formState, watch} = useForm({shouldUnregister: true})
  const tagOwner = useSelector((state) => state.tagOwner)
  const hostname = useSelector((state) => state.hostname)
  const questionsUrl = useSelector((state) => state.questionsUrl)?.replace("@tag_owner_id@", tagOwner.id)?.replace("@video_room_id@", videoRoom.id)
  const [sending, setSending] = useState(false)
  const [showThankYou, setShowThankYou] = useState(false)
  const dispatch = useDispatch()
  const t = useTranslation(null, true)

  const validateForm = (data) => {
    setSending(true)
    // myPlayer.currentTime(180);

    console.log("data", data, questionsUrl)
    axios.post(questionsUrl.replace("@video_room_id@", videoRoom.id), data).then(response => {
        setSending(false)
        console.log("response", response.data)
        if (response.data.status == "OK") {
          console.log(response.data.question)
          // dispatch(setActiveTab("Question"))
          reset()
          dispatch(setQuestions(response.data.question))
          setShowThankYou(true)
          setTimeout(function () {
            setShowThankYou(false)
          }, 1500);
        } else {
          console.error(response.data.errors)

          {
            _.map(response.data.errors, (messages, field) => {
              {
                _.map(messages, (message, index) => {
                  console.log("adding error", field, message)
                  setError(field, {type: "not valid", message: message})
                })
              }
            })
          }


          setTimeout(function () {
            let elem = document.getElementsByClassName("Mui-error")
            if (elem && elem.length > 0)
              elem[0].parentElement.scrollIntoView({behavior: 'smooth', block: 'start'})
          }, 200)

        }
      },
      error => {
        alert(error)
        console.error(error)
      }).catch(ex => {
      setSending(false)
      console.error(ex)
    })
  }

  if (options?.enabled == false) {
    return null
  }
  if (!questionsUrl) {
    return <div className="alert alert-danger">No questionsUrl provided.</div>
  }
  return (
    <div className={"videoroom-question-form"}>
      {showThankYou ? (
        <div className="row">
          <div className="col">
            <div className="alert alert-success mt-2">
              {videoRoom.question_form_thank_you_text || t("video_room.question_form.thank_you_text") || options?.thankYouText || "Nachricht gesendet!"}
            </div>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit(validateForm)}>
          <div className="row">
            <div className="col">
              <small className={classNames("question-form-label ", {"d-none": props.hidden })} id="question"
                     style={{color: props.color ? props.color : options?.color || "white"}}>{options?.label || videoRoom.question_form_label_text || t("video_room.question_form.send_message") || "Nachricht senden:"}</small>
              <div className="row">
                <div className={classNames((options?.leftColumnClass || "col-9"), "pr-2")}>
                  <Controller
                    name="question"
                    control={control}
                    defaultValue={""}
                    render={({ field }) => <TextField
                      {...field}
                      multiline
                      placeholder={videoRoom.question_form_placeholder || options?.placeholder}
                      readOnly={!sending}
                      disabled={sending}
                      color="primary"
                      required={true}
                      id="question"
                      size="small"
                      autoFocus
                      maxLength="1000"
                      autoComplete="off"
                      error={errors["questions"] != null}
                      style={{backgroundColor: options?.input?.backgroundColor || "#FFF", marginTop: "5px", color: options?.input?.color || "#000"}}
                      className="w-100 p-1"
                    />}
                  />
                </div>
                <div className={classNames((options?.rightColumnClass || "col-3"), "pl-0")}>
                  <button
                    className={classNames("btn btn-block btn-stream btn-sm float-right", options?.sendButtonClass)}
                    style={Object.assign({marginTop: "5px", height: "45px"}, (options?.buttonStyles || {}))}
                    type="submit">
                    <i
                      className={classNames("fa fa-fw", sending ? (options?.sendingIcon || "fa-spinner fa-spin") : (options?.sendIcon || "fa-angle-right"))}/>
                    {(options?.sendButtonText && options?.sendButtonText != "" || !!videoRoom.question_form_send_button_text) &&
                      <span
                        className="d-ddddnone ddddd-xl-inline-block">{videoRoom.question_form_send_button_text || t("video_room.question_form.send_button_text") || options?.sendButtonText || " Send"}</span>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

    </div>
  )
}


